/**
 * SuperBrain Refund Policy
 * © 2026 A-1 Affiliate Marketing LLC - All Rights Reserved
 */

import React from 'react';
import MachineTranslationNotice from './MachineTranslationNotice';
import './LegalPage.css';

const RefundPolicy = () => {
  return (
    <div className="legal-page" data-testid="refund-policy-page">
      <div className="legal-container">
        <button onClick={() => window.history.back()} className="back-btn" data-testid="refund-back-btn">← Back</button>

        <MachineTranslationNotice />

        <h1>REFUND POLICY</h1>
        <p className="subtitle">SuperBrain Agentic Aggregate</p>
        <p className="effective-date">Effective Date: February 11, 2026</p>
        <p className="copyright">© 2026 A-1 Affiliate Marketing LLC. All Rights Reserved.</p>

        <section>
          <h2>1. Free Trial</h2>
          <p>Eligible new accounts receive a <strong>3-day free trial</strong>, and a payment method is collected at signup. The selected subscription begins automatically when the trial ends unless you cancel before the end of the trial. No subscription charge is due when you cancel in time.</p>
        </section>

        <section>
          <h2>2. Refunds on Paid Subscriptions</h2>
          <p><strong>Monthly subscriptions:</strong> You may request a full refund of the most recent subscription charge within <strong>7 days</strong> of that charge if usage during that billing period does not exceed 1,000 queries. Send the request to <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a>.</p>
          <p><strong>Yearly subscriptions:</strong> You may request a prorated refund within the first <strong>30 days</strong> after purchase. After that period, yearly subscription charges are not refundable except where applicable law requires otherwise; access remains available through the current paid period.</p>
        </section>

        <section>
          <h2>3. Non-Refundable Items</h2>
          <ul>
            <li>Monthly charges after the 7-day request period or when usage exceeds 1,000 queries</li>
            <li>Yearly charges after the first 30 days, except where applicable law requires otherwise</li>
            <li>Image generation credits already consumed</li>
            <li>One-time add-on purchases</li>
            <li>Accounts terminated for Terms of Service violations</li>
          </ul>
        </section>

        <section>
          <h2>4. Cancellation</h2>
          <p>You can cancel from your dashboard at any time. Cancellation stops future renewals; you retain access through the end of your current paid period. Monthly cancellations do not receive prorated refunds for the unused part of a billing period. To avoid the first subscription charge, cancel before the 3-day trial ends.</p>
        </section>

        <section>
          <h2>5. How to Request a Refund</h2>
          <p>Email <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a> with:</p>
          <ul>
            <li>The email address on your SuperBrain account</li>
            <li>The date of the charge you'd like refunded</li>
            <li>A brief reason (optional, helps us improve)</li>
          </ul>
          <p>Approved refunds are sent to the original payment method. Processing time depends on the payment provider. These terms do not limit refund rights that cannot be waived under applicable law.</p>
        </section>

        <section>
          <h2>6. Chargebacks</h2>
          <p>Please contact us first — we resolve disputes faster than your bank can. Filing a chargeback without first contacting us results in immediate account termination and may be referred for collections.</p>
        </section>

        <section>
          <h2>7. Contact</h2>
          <p>A-1 Affiliate Marketing LLC<br/>Email: <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;
